import { useMutation, useQuery } from '@tanstack/react-query'

import api from '@/api'
import { queryClient } from '@/react-query/client'

export const API_KEYS_KEY = 'apiKeys'
export const WEBHOOKS_KEY = 'webhooks'

// --- API Keys ---

export const useApiKeys = () => {
  return useQuery({
    queryKey: [API_KEYS_KEY],
    queryFn: async () => (await api.getApiKeys()).data.data,
  })
}

export const useCreateApiKey = () => {
  return useMutation({
    mutationFn: async (data: { name: string }) => {
      return (await api.createApiKey(data)).data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_KEYS_KEY] })
    },
  })
}

export const useRevokeApiKey = () => {
  return useMutation({
    mutationFn: async (keyId: string) => {
      return await api.revokeApiKey(keyId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_KEYS_KEY] })
    },
  })
}

// --- Webhooks ---

export const useWebhooks = () => {
  return useQuery({
    queryKey: [WEBHOOKS_KEY],
    queryFn: async () => (await api.getWebhooks()).data.data,
  })
}

export const useCreateWebhook = () => {
  return useMutation({
    mutationFn: async (data: { url: string; events: string[] }) => {
      return (await api.createWebhook(data)).data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WEBHOOKS_KEY] })
    },
  })
}

export const useUpdateWebhook = () => {
  return useMutation({
    mutationFn: async ({
      webhookId,
      ...data
    }: {
      webhookId: string
      url?: string
      events?: string[]
      isActive?: boolean
    }) => {
      return (await api.updateWebhook(webhookId, data)).data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WEBHOOKS_KEY] })
    },
  })
}

export const useDeleteWebhook = () => {
  return useMutation({
    mutationFn: async (webhookId: string) => {
      return await api.deleteWebhook(webhookId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [WEBHOOKS_KEY] })
    },
  })
}
